import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom'
import WeaverService from 'Services/WeaverService'

BaseRoute = ({ isPublic, ...props }) ->

  <Route {...props}>
    {
      if not isPublic and not WeaverService.isAuthenticated()
        <Redirect to='/login' />
      else
        props.children
    }
  </Route>
export default BaseRoute
